<template>
  <div class="personal_center account_settings">
    <div class="parkSwitch" v-if="parkInfo">
      当前园区：
      {{parkInfo.name}} - {{company}}
      <a href="javascript:;" @click="dialogParams2.dialogVisible = true">切换园区</a>
    </div>
    <div class="m">
      <div class="left_box">
        <el-menu :default-openeds="['1','2','3','4']" :default-active="curActive">
          <el-submenu index="1">
            <template slot="title">
              <i class="iconfont">&#xe63a;</i>
              <span>个人资料</span>
            </template>
            <el-menu-item index="1-1">
              <router-link to="/personal_center/account_settings/essential_information">基本信息</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="iconfont">&#xe6cb;</i>
              <span>账户安全</span>
            </template>
            <el-menu-item index="2-1">
              <router-link to="/personal_center/account_settings/change_password">修改密码</router-link>
            </el-menu-item>
            <el-menu-item index="2-2">
              <router-link to="/personal_center/account_settings/mobile_phone_binding">手机绑定</router-link>
            </el-menu-item>
            <el-menu-item index="2-3">
              <router-link to="/personal_center/account_settings/mail_binding">邮箱绑定</router-link>
            </el-menu-item>
            <!-- <el-menu-item index="2-4">
              <router-link to="/personal_center/account_settings/QQ_binding">QQ绑定</router-link>
            </el-menu-item>
            <el-menu-item index="2-5">
              <router-link to="/personal_center/account_settings/WX_binding">微信绑定</router-link>
            </el-menu-item> -->
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="iconfont">&#xe6cb;</i>
              <span>高级设置</span>
            </template>
            <el-menu-item index="3-1">
              <router-link to="/personal_center/account_settings/changeEnterprise">设置默认企业/园区</router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right_box">
        <router-view></router-view>
      </div>
    </div>
    <!-- 切换园区 -->
    <switchPark :dialogParams="dialogParams2" />
  </div>
</template>

<script>
const rouerObj = [
  {
    pathKey: "/personal_center/account_settings/essential_information",
    index: "1-1"
  },
  {
    pathKey: "/personal_center/account_settings/change_password",
    index: "2-1"
  },
  {
    pathKey: "/personal_center/account_settings/mobile_phone_binding",
    index: "2-2"
  },
  {
    pathKey: "/personal_center/account_settings/mail_binding",
    index: "2-3"
  },
  {
    pathKey: "/personal_center/account_settings/QQ_binding",
    index: "2-4"
  },
  {
    pathKey: "/personal_center/account_settings/WX_binding",
    index: "2-5"
  }
];
import switchPark from "@/components/dialog/switchPark.vue";
export default {
  components:{
    switchPark
  },
  data() {
    return {
      curActive: "1-1",
      dialogParams2: {
        dialogVisible: false
      }
    };
  },
  created() {
    this.setCurActive();
    // this.curActive2();
  },
  computed:{
    company() {
      return this.$store.state.company;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  methods: {
    // curActive2() {
    //   let path = this.$route.path;
    //   let index = "1-1";
    //   rouerObj.forEach(item => {
    //     if (path.indexOf(item.pathKey) > -1) {
    //       index = item.index;
    //     }
    //   });
    //   this.curActive = index;
    // },
    //设置选中菜单
    setCurActive() {
      let path = this.$route.path;
      let active = '';
      if (path.indexOf('base_info') !== -1) {
        active = '1-1';
      } else if (path.indexOf('change_password') !== -1) {
        active = '2-1'
      } else if (path.indexOf('mobile_phone_binding') !== -1) {
        active = '2-2'
      } else if (path.indexOf('mail_binding') !== -1) {
        active = '2-3'
      } else if (path.indexOf('changeEnterprise') !== -1) {
        active = '3-1'
      }
      this.curActive = active;
    }
  }
};
</script>

<style lang="scss">
@import "../index.scss";
.account_settings {
  .parkSwitch {
    width: 1200px;
    margin: 0 auto !important;
    padding-top: 20px;
    color: #333;
    font-size: 14px;

    a {
      margin-left: 10px;
      color: #4c84ff;
    }
  }
}
</style>
